import React from 'react';
import { Vehicle } from 'core/models/vehicle';
import styled from '@emotion/styled';
import { MiniSpeakerButton } from 'components/views/atoms/MiniSpeakerButton';
import { ToggleSpeakerButtonProps, withToggleSpeaker } from '../ToggleSpeaker';
import { Telemetry } from 'core/models/FMS/Telemetry';
import { FMSStatus } from 'components/views/atoms/FMSStatus';

type FrameProps = {
    darkMode: boolean;
}

const Frame = styled.div<FrameProps>(props => ({
    overflow: 'hidden',
    fontFamily: '\'Cabin Sketch\', arial, serif',
    color: props.darkMode ? 'white' : 'black',
    ['> h1']: {
        margin: 0,
        fontSize: '20px',
        textShadow: props.darkMode ? '0 0 0' : '3px 3px 0 #ddd',
    },
    ['> h3']: {
        margin: 0,
        fontSize: '18px',
        fontWeight: 'normal',
    },
}));

type MySpeakerButtonProps = {} & ToggleSpeakerButtonProps;

function MySpeakerButton(props: MySpeakerButtonProps) {
    const { mute, disabled, onClick } = props;

    return (
        disabled
            ? <React.Fragment />
            : < React.Fragment >
                {' '}
                <MiniSpeakerButton mute={mute} onClick={onClick} />
            </React.Fragment >
    );
}

const Online = styled.div({
    width: 'fit-content',
    border: 'thin solid',
    borderRadius: '4px',
    padding: '2px',
    fontWeight: 'bold',
    borderColor: 'seagreen',
    color: 'seagreen',
});

const Offline = styled.div<FrameProps>(props => ({
    width: 'fit-content',
    border: 'thin solid',
    borderRadius: '4px',
    padding: '2px',
    borderColor: props.darkMode ? 'white' : 'black',
    color: props.darkMode ? 'white' : 'black',
}));

const ToggleSpeaker = withToggleSpeaker(MySpeakerButton);

export type VehicleStatusProps = {
    className?: string;
    name: string;
    darkMode?: boolean;
    stream?: MediaStream | null;
    status?: Telemetry.Status;
    isOnline?: boolean;
} & Vehicle.Status;

export const VehicleStatus = (props: VehicleStatusProps) => {
    const { className, name, darkMode, stream, currentSpeed, targetSpeed, status, isOnline } = props;
    return (
        <Frame className={className} darkMode={darkMode == true}>
            <h1 >Vehicle: {name}<ToggleSpeaker stream={stream ?? null} /></h1>
            <FMSStatus status={status} />
            {
                isOnline === undefined
                    ? <></>
                    : isOnline
                        ? <Online>ONLINE</Online>
                        : <Offline darkMode={darkMode == true}>OFFLINE</Offline>
            }
            <h3>Speed: {currentSpeed.toFixed(2)} km/h</h3>
            <h3>Target Speed: {targetSpeed.toFixed(2)} km/h</h3>
        </Frame>
    );
};
